import React from 'react'
import { Avatar, Heading, nameFromRecord } from '@myxplor/ui'
import { ConditionalWrapper } from '../../conditional-link'
import { IS_EMBEDDED } from '../../embedded'
import './record-heading.css'

const RecordHeading = ({ record, children }) => (
  <div className="recordHeading--wrapper layoutPosition--sticky">
    <ConditionalWrapper wrap={IS_EMBEDDED}>
      <a href={document.location.href} className="hidden-link" target="_blank">
        <div className="recordHeading--details">
          <Avatar user={record} />
          <Heading small compact>
            {nameFromRecord(record)}
          </Heading>
        </div>
      </a>
    </ConditionalWrapper>

    {children}
  </div>
)

const RecordSubHeading = ({ children }) => (
  <div className="recordSubHeading--wrapper">{children}</div>
)

export { RecordSubHeading }

export default RecordHeading



// WEBPACK FOOTER //
// ./src/ui/record-heading/index.jsx